export const admin_users = [
  { id: 'fc15c4d02d2f11ebb6924ddbd99a612c', name: 'Hilson' },
  { id: '98d420802dc811ebb63fcd3c766b9d6b', name: 'Jimmy' },
  { id: '6f2fe1402ded11ebb1c44f62657e3120', name: 'Gong' },
];

export const products = [
  { id: 'vip', name: 'vip' },
  { id: 'diamond', name: 'diamond' },
];

export const status_types = [
  { id: 'none', name: 'none' },
  { id: 'verifying', name: 'verifying' },
  { id: 'verified', name: 'verified' },
  { id: 'failed', name: 'failed' },
];

export const boolean_types = [
  { id: true, name: 'true' },
  { id: false, name: 'false' },
];

export const scenarios = [
  { id: 'store', name: 'store' },
  { id: 'coupon', name: 'coupon' },
  { id: 'reserve', name: 'reserve' },
  { id: 'sold-out', name: 'sold-out' },
];

export const priceUnits = [{ id: 'CAD' }, { id: 'USD' }, { id: 'RMB' }];

export const gender_typs = [
  { id: 'Woman', name: 'Woman' },
  { id: 'Man', name: 'Man' },
  { id: 'Non-binary', name: 'Non-binary' },
];

export const purpose_types = [
  { id: 'Make friends', name: 'Make friends' },
  { id: 'Long-term relationship', name: 'Long-term relationship' },
  { id: 'Marital partner', name: 'Marital partner' },
  { id: 'Short-term relationship', name: 'Short-term relationship' },
];

export const religion_typs = [
  { id: 'Agnostic', name: 'Agnostic' },
  { id: 'Atheist', name: 'Atheist' },
  { id: 'Buddhist', name: 'Buddhist' },
  { id: 'Catholic', name: 'Catholic' },
  { id: 'Christian', name: 'Christian' },
  { id: 'Hindu', name: 'Hindu' },
  { id: 'Muslim', name: 'Muslim' },
  { id: 'Sikh', name: 'Sikh' },
  { id: 'Spiritual', name: 'Spiritual' },
  { id: 'Taoism', name: 'Taoism' },
  { id: 'Other/None', name: 'Other/None' },
];

export const excercise_types = [
  { id: 'Active', name: 'Active' },
  { id: 'Sometimes', name: 'Sometimes' },
  { id: 'Almost never', name: 'Almost never' },
];

export const smoking_types = [
  { id: 'Never', name: 'Never' },
  { id: 'Socially', name: 'Socially' },
  { id: 'Sometimes', name: 'Sometimes' },
  { id: 'Often', name: 'Often' },
  { id: 'Quitting', name: 'Quitting' },
];

export const education_types = [
  { id: 'High school', name: 'High school' },
  { id: 'Trad/Tech school', name: 'Trad/Tech school' },
  { id: 'Bachelor degree', name: 'Bachelor degree' },
  { id: 'Master degree', name: 'Master degree' },
  { id: 'Doctorate', name: 'Doctorate' },
  { id: 'Other', name: 'Other' },
];

export const pets = [
  { id: 'Dog(s)', name: 'Dog(s)' },
  { id: 'Cat(s)', name: 'Cat(s)' },
  { id: 'None', name: 'None' },
  { id: "Don't want", name: "Don't want" },
  { id: 'Other(s)', name: 'Other(s)' },
];

export const marital_types = [
  { id: 'Single', name: 'Single' },
  { id: 'Divorced', name: 'Divorced' },
  { id: 'Widowed', name: 'Widowed' },
  { id: 'Separated', name: 'Separated' },
];

export const drinking = [
  { id: 'Never', name: 'Never' },
  { id: 'Socially', name: 'Socially' },
  { id: 'Sometimes', name: 'Sometimes' },
  { id: 'Often', name: 'Often' },
  { id: 'Quitting', name: 'Quitting' },
];
